import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, XCircle, ShieldCheck, Download, Lock, Clock, Sparkles, MessageSquare, AlertTriangle, Package, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouDownsalePage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Downsale-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-4835" data-mp="18igx8wiqim3r">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4836" data-mp="14g2esdiz9od0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4837" data-mp="14ioiu36ntlqh" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-4838" data-mp="pw9es4g827x6">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-4839" data-mp="fw8uogaj3nrx">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-4840" data-mp="ku0jv2jsgvsf" />
          <p className="text-[11px] sm:text-xs md:text-sm font-black uppercase tracking-wide" data-id="element-4841" data-mp="18kmsauxpgi2y">
            ÚLTIMA OPORTUNIDAD — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1 tabular-nums" data-id="element-4842" data-mp="1diy0z2c9kmjl">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-4843" data-mp="1riqqiuc20wpz">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-4844" data-mp="1rhxpm9zs11fr">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-4845" data-mp="1wb9ztf3pl5oz" />
          <p className="text-white font-bold text-[11px] sm:text-xs md:text-sm uppercase tracking-tight leading-tight" data-id="element-4846" data-mp="3gy9pwhz50gqa">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 md:py-12 lg:py-16" data-id="element-4847" data-mp="3lr2tv3ms7l1b">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-14 lg:mb-16" data-id="element-4848" data-mp="2y18i6pe782in">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5 md:mb-6" data-id="element-4849" data-mp="2y3mbaspbj4nk">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-4850" data-mp="372pvy144vs46" />
            <span className="text-amber-400 text-[11px] md:text-sm font-bold uppercase tracking-widest" data-id="element-4851" data-mp="3703p63p2hgn0">
              Una sola oferta más antes de irte
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] tracking-tight mb-5 md:mb-6" data-id="element-4852" data-mp="ma4lw7iyvvqq">
            Espera —{' '}
            <span className="text-amber-400" data-id="element-4853" data-mp="1cnkt03nqnmel">
              Antes de Irte, Tengo Algo Más
            </span>
          </h1>

          <div className="flex justify-center mb-6 md:mb-8" data-id="element-4854" data-mp="1hmxcqfjbcdcy">
            <img src="https://cdn.magicpatterns.com/uploads/fnSrv3cQGqXfuDMy26kNxi/100_Mensajes.png" alt="100 Mensajes de WhatsApp — Versión LITE" className="w-full max-w-lg md:max-w-2xl h-auto rounded-2xl shadow-[0_25px_70px_-15px_rgba(0,0,0,0.7)] ring-1 ring-white/10" data-id="element-4855" data-mp="1mlibeaix2oza" />
          </div>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-4856" data-mp="20l0594b2ksfi">
            Entiendo que <span className="text-white font-bold" data-id="element-4857" data-mp="25b6v17hbiizc">$27</span>{' '}
            quizás no era el momento. Pero no quiero que llegues al webinar{' '}
            <span className="text-white font-bold" data-id="element-4858" data-mp="2aa1iimq8cvps">
              sin los mensajes esenciales.
            </span>
          </p>
        </section>

        {/* LITE Version Section */}
        <section className="mb-10 md:mb-14" data-id="element-4859" data-mp="2jcarv99rij1l">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12" data-id="element-4860" data-mp="7o60w0ro5fvr">
            <div className="flex items-start gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-4861" data-mp="3lrgvdc9ka2w">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-4862" data-mp="3usc6csmo79xt">
                <Package className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-4863" data-mp="3pvvd5k0m65dv" />
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black text-white leading-tight pt-0.5" data-id="element-4864" data-mp="re7xrkk9lw0m">
                Te Tengo La <span className="text-amber-400" data-id="element-4865" data-mp="hm2ago4yk2rr">Versión LITE</span>{' '}
                del Manual
              </h2>
            </div>

            {/* What's included / not included — side by side on desktop */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8" data-id="element-4866" data-mp="1a2whi370hvat">
              {/* SÍ incluye */}
              <div data-id="element-4867" data-mp="15b4qjrjy1nk5">
                <div className="flex items-center gap-2 mb-4" data-id="element-4868" data-mp="15alegrgz5te1">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0" data-id="element-4869" data-mp="2zktcc0sostj7" />
                  <p className="text-white font-bold text-base md:text-lg" data-id="element-4870" data-mp="33kai6vc0zsow">
                    Lo que SÍ incluye:
                  </p>
                </div>
                <ul className="space-y-3 text-gray-300 text-sm md:text-base lg:text-lg" data-id="element-4871" data-mp="2ut1x2mezea8d">
                  <li className="flex items-start gap-3" data-id="element-4872" data-mp="2uqp47e7oqfgj">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4873" data-mp="2fuzr65kh9cny" />
                    <span data-id="element-4874" data-mp="2kwfclyqkhl6v">
                      <span className="text-white font-bold" data-id="element-4875" data-mp="2ksrk92wuz4tq">100 mensajes</span>{' '}
                      (los esenciales — los más probados)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4876" data-mp="2bwa41l9n0gr4">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4877" data-mp="54rhm8v462qp" />
                    <span data-id="element-4878" data-mp="a1rkkawo2pdl">
                      Cubre los{' '}
                      <span className="text-white font-bold" data-id="element-4879" data-mp="k6hscxer4npq">
                        6 nichos principales
                      </span>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4880" data-mp="f5tv3tzxjan2">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4881" data-mp="szusajb8gplb" />
                    <span data-id="element-4882" data-mp="o6s12htxhs8a">
                      Incluye las{' '}
                      <span className="text-white font-bold" data-id="element-4883" data-mp="12wfz9a6tcars">
                        5 Reglas de Oro del WhatsApp
                      </span>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4884" data-mp="1byfhu6xh7mwu">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 flex-shrink-0 mt-1" data-id="element-4885" data-mp="1bvt9i52rh3dk" />
                    <span data-id="element-4886" data-mp="17uhko1rpom6f">
                      <span className="text-white font-bold" data-id="element-4887" data-mp="3doqwvldrr3r4">
                        Misma garantía de 7 días
                      </span>
                    </span>
                  </li>
                </ul>
              </div>

              {/* NO incluye */}
              <div data-id="element-4888" data-mp="2150ftelhtyz">
                <div className="flex items-center gap-2 mb-4" data-id="element-4889" data-mp="72c8ltkngv66">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0" data-id="element-4890" data-mp="70ho2gdaj52m" />
                  <p className="text-white font-bold text-base md:text-lg" data-id="element-4891" data-mp="btkkqxdd6un1">
                    Lo que NO incluye:
                  </p>
                </div>
                <ul className="space-y-3 text-gray-400 text-sm md:text-base lg:text-lg" data-id="element-4892" data-mp="3faat3iwf5jrw">
                  <li className="flex items-start gap-3" data-id="element-4893" data-mp="3k8kpfwtvqqf3">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4894" data-mp="3k94a3lawzswt" />
                    <span data-id="element-4895" data-mp="3o94lsy6mpq06">Los otros 100 mensajes de situaciones avanzadas</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4896" data-mp="3tau14q0vwpu2">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4897" data-mp="13l01wbw5jp5v" />
                    <span data-id="element-4898" data-mp="18iifwgp10ukq">La plantilla editable en Google Docs</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4899" data-mp="1inrqfco6xaqb">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-4900" data-mp="1ipcld3ef2vop" />
                    <span data-id="element-4901" data-mp="1dq8e4ib1z810">Acceso a futuras actualizaciones</span>
                  </li>
                </ul>
              </div>
            </div>

            <p className="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed border-l-2 border-amber-400 pl-4 italic" data-id="element-4902" data-mp="14wd9rchr9lmf">
              Pero tienes lo{' '}
              <span className="text-white font-bold not-italic" data-id="element-4903" data-mp="zue4ty6dagnd">
                SUFICIENTE para arrancar el jueves
              </span>{' '}
              después del webinar y cerrar tus primeros clientes.
            </p>
          </div>
        </section>

        {/* CTA + Pricing */}
        <section className="mb-8" data-id="element-4904" data-mp="lz2a3qs7oq6g">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-4905" data-mp="2kcc0d9vbwyyx">
            {/* Price summary */}
            <div className="text-center mb-7 md:mb-8" data-id="element-4906" data-mp="304a3dujqk3tn">
              <div className="inline-flex items-center gap-1.5 text-gray-400 text-sm md:text-base mb-2" data-id="element-4907" data-mp="306wajt2pshbc">
                <DollarSign className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-4908" data-mp="2w5sylhnsf5fe" />
                <span data-id="element-4909" data-mp="3a14ye3gsvm36">Inversión única</span>
              </div>
              <p className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-2 leading-none" data-id="element-4910" data-mp="355fz818p077e">
                $17{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-4911" data-mp="2hc7ig702a1dl">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-4912" data-mp="2r5euubt7yhn6">
                Pago único · Descarga inmediata
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 17,
                currency: 'USD'
              });
            }
          }} data-id="element-4913" data-mp="1ymrhxjodm8x6">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-sm sm:text-base md:text-lg lg:text-xl uppercase tracking-tight py-5 md:py-6 lg:py-7 px-4 sm:px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-4914" data-mp="71whlrj4gm3">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-4915" data-mp="ix9szl0q48tb">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-4916" data-mp="nv1u95n9d7a6" />
                  LLEVARME LA VERSIÓN LITE POR $17
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-4917" data-mp="33lo4u0ft2qvy" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-4918" data-mp="1968yc4oqazbv">
              <span className="flex items-center gap-1.5" data-id="element-4919" data-mp="14epoxy8qal2q">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4920" data-mp="10ep51y2v1hoa" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4921" data-mp="vgdqxb5j8l09">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4922" data-mp="qg9bzpk9vyc5" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-4923" data-mp="lgmx7bosqa18">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-4924" data-mp="lj96pgv8yzm3" />
                Pago seguro
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-4925" data-mp="2btvm113ngo3z">
              <Link to="/thank-you" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-4926" data-mp="2bu3zau3opvfp">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 md:mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center gap-4" data-id="element-4927" data-mp="7cpb3mo2frr7">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-4928" data-mp="bcq1m5ofvtem">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-4929" data-mp="3fqo5wkzax734" />
              </div>
              <div className="text-center sm:text-left" data-id="element-4930" data-mp="3jsrv0cew8a6v">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-4931" data-mp="3jve26axvgnok">
                  Misma Garantía: 7 Días
                </h4>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-4932" data-mp="z3ln6l2axsdf">
                  100% reembolso si no te sirve. Sin preguntas, sin letra
                  pequeña.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6" data-id="element-4933" data-mp="xmoppb9m7pca">
          <Clock className="w-4 h-4 inline mr-1.5 mb-0.5" data-id="element-4934" data-mp="1blxsn98t8myb" />
          Esta oferta no estará disponible después de salir de esta página.
        </div>
      </main>

      <Footer data-id="element-4935" data-mp="17lxezqtjcfsb" />
    </div>;
}